import { Notification } from 'modules/core/domain/interfaces/supabase/notifications/types';
import React from 'react';
import { UDText } from 'ud-ui/components';
import NotificationComponent from './notification';

interface Props {
  notification: Partial<Notification>;
}

const NotificationPreview: React.FC<Props> = ({ notification }) => {
  const previewNotification: Notification = {
    id: 0,
    type: notification.type || 'info',
    title: notification.title || 'Предпросмотр заголовка',
    text: notification.text || 'Предпросмотр текста уведомления',
    createdAt: new Date().toISOString(),
    userId: notification.userId || null,
    order: 0,
  };

  return (
    <div className="mt-4">
      <UDText type="title-3" className="mb-3">
        Предпросмотр:
      </UDText>
      <NotificationComponent notification={previewNotification} />
    </div>
  );
};

export default NotificationPreview;
